"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVATAR_GROUP_COLOR_8 = exports.AVATAR_GROUP_COLOR_7 = exports.AVATAR_GROUP_COLOR_6 = exports.AVATAR_GROUP_COLOR_5 = exports.AVATAR_GROUP_COLOR_4 = exports.AVATAR_GROUP_COLOR_3 = exports.AVATAR_GROUP_COLOR_2 = exports.AVATAR_GROUP_COLOR_1 = exports.AVATAR_GROUP_VIEWBOX_SIZE = void 0;
exports.AVATAR_GROUP_VIEWBOX_SIZE = 100;
exports.AVATAR_GROUP_COLOR_1 = '#8EB8A4';
exports.AVATAR_GROUP_COLOR_2 = '#A7C461';
exports.AVATAR_GROUP_COLOR_3 = '#F2BC3E';
exports.AVATAR_GROUP_COLOR_4 = '#EE7534';
exports.AVATAR_GROUP_COLOR_5 = '#C54444';
exports.AVATAR_GROUP_COLOR_6 = '#CC92E9';
exports.AVATAR_GROUP_COLOR_7 = '#6A2A88';
exports.AVATAR_GROUP_COLOR_8 = '#7BD0CE';
//# sourceMappingURL=constants.js.map